import * as React from 'react';
import {useEffect, useRef, useState} from "react";

import {SwipeableDrawer, Box, styled} from "@mui/material";

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: '#141624',
}));

const Puller = styled(Box)(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: '#ffffff',
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
}));

const DRAWER = 50;

export const Drawer = ({ children }) => {
    const [openDrawer, setOpenDrawer] = useState(true);

    const toggleDrawer = (newOpen) => () => {
        setOpenDrawer(newOpen);
    };

    return (
        <SwipeableDrawer
            anchor="bottom"
            open={openDrawer}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            swipeAreaWidth={DRAWER}
            disableSwipeToOpen={false}
            ModalProps={{
                keepMounted: true,
            }}
        >
            <StyledBox
                sx={{
                    position: 'absolute',
                    top: -DRAWER,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                    visibility: 'visible',
                    height: DRAWER,
                    right: 0,
                    left: 0,
                }}
            >
                <Puller/>
            </StyledBox>

            <StyledBox
                sx={{
                    p: 2,
                    height: '100%',
                    overflow: 'auto',
                }}
            >
                {children}
            </StyledBox>
        </SwipeableDrawer>
    );
}
